import { sendSupersetTrackedEventToApp } from '@/shared/external/superset'

export const carStoryTracking = {
  // ==========================================
  // 0) 공통 (상단 Tab + PC 다운로드 버튼)
  // ==========================================

  /** 상단 Tab 클릭 */
  clickTab: (menuName: string) => {
    sendSupersetTrackedEventToApp({
      prefix: 'common',
      eventName: 'magazine_tab_click',
      label: menuName,
      code: 'top_menu',
      type: 'tab',
    })
  },

  /** PC 상단 다운로드 버튼 노출 */
  showDownloadButton: () => {
    sendSupersetTrackedEventToApp({
      prefix: 'common',
      eventName: 'magazine_tab_show',
      label: '다운로드',
      code: 'top_menu',
      type: 'button',
    })
  },

  /** PC 상단 다운로드 버튼 클릭 */
  clickDownloadButton: () => {
    sendSupersetTrackedEventToApp({
      prefix: 'common',
      eventName: 'magazine_tab_click',
      label: '다운로드',
      code: 'top_menu',
      type: 'button',
    })
  },

  // ==========================================
  // 1) 매거진 - 홈
  // ==========================================

  /** 화면 노출 */
  showHomePage: () => {
    sendSupersetTrackedEventToApp({
      prefix: 'common',
      eventName: 'magazine_home_show',
      label: '드라이브 매거진 - 홈',
      type: 'page',
    })
  },

  // 1-2) 상단 콘텐츠 카드 (DriveMagazineSwiper)

  /** 상단 콘텐츠 카드 노출 */
  showTopContentCard: (title: string, index: number) => {
    sendSupersetTrackedEventToApp({
      prefix: 'common',
      eventName: 'magazine_home_show',
      label: title,
      code: 'top_contents',
      type: 'card',
      index,
    })
  },

  /** 상단 콘텐츠 카드 클릭 */
  clickTopContentCard: (title: string, index: number) => {
    sendSupersetTrackedEventToApp({
      prefix: 'common',
      eventName: 'magazine_home_click',
      label: title,
      code: 'top_contents',
      type: 'card',
      index,
    })
  },

  /** 상단 콘텐츠 가로 스크롤 (1회) */
  scrollTopContents: () => {
    sendSupersetTrackedEventToApp({
      prefix: 'common',
      eventName: 'magazine_home_scroll',
      label: '상단 콘텐츠',
      code: 'top_contents',
      type: 'card',
    })
  },

  // 1-3) 지금 뜨는 이야기 (TrendingStoriesSection)

  /** '지금 뜨는 이야기' 섹션 노출 */
  showTrendingSection: () => {
    sendSupersetTrackedEventToApp({
      prefix: 'common',
      eventName: 'magazine_home_show',
      label: '지금 뜨는 이야기',
      code: 'trending_story',
      type: 'section',
    })
  },

  /** '지금 뜨는 이야기' 카드 노출 */
  showTrendingCard: (title: string) => {
    sendSupersetTrackedEventToApp({
      prefix: 'common',
      eventName: 'magazine_home_show',
      label: title,
      code: 'trending_story',
      type: 'card',
    })
  },

  /** '지금 뜨는 이야기' 카드 클릭 */
  clickTrendingCard: (title: string) => {
    sendSupersetTrackedEventToApp({
      prefix: 'common',
      eventName: 'magazine_home_click',
      label: title,
      code: 'trending_story',
      type: 'card',
    })
  },

  // 1-4) 차량관리의 모든 것 (VehicleManagementSection)

  /** '차량관리의 모든 것' 카드 노출 */
  showCarcareAllCard: (title: string) => {
    sendSupersetTrackedEventToApp({
      prefix: 'common',
      eventName: 'magazine_home_show',
      label: title,
      code: 'carcare_all',
      type: 'card',
    })
  },

  /** '차량관리의 모든 것' 카드 클릭 */
  clickCarcareAllCard: (title: string) => {
    sendSupersetTrackedEventToApp({
      prefix: 'common',
      eventName: 'magazine_home_click',
      label: title,
      code: 'carcare_all',
      type: 'card',
    })
  },

  /** '차량관리의 모든 것' 전체보기 클릭 */
  clickCarcareAllMore: () => {
    sendSupersetTrackedEventToApp({
      prefix: 'common',
      eventName: 'magazine_home_click',
      label: '차량관리의 모든 것 - 전체보기',
      code: 'carcare_all_more',
      type: 'button',
    })
  },

  // 1-5) 마이클 정비사 이야기 (MechanicStoriesSection)

  /** '마이클 정비사 이야기' 섹션 노출 */
  showMechanicSection: () => {
    sendSupersetTrackedEventToApp({
      prefix: 'common',
      eventName: 'magazine_home_show',
      label: '마이클 정비사 이야기',
      code: 'mechanic_story',
      type: 'section',
    })
  },

  /** '마이클 정비사 이야기' 카드 스크롤 (1회) */
  scrollMechanic: () => {
    sendSupersetTrackedEventToApp({
      prefix: 'common',
      eventName: 'magazine_home_scroll',
      label: '마이클 정비사 이야기',
      code: 'mechanic_story',
      type: 'card',
    })
  },

  /** '마이클 정비사 이야기' 카드 노출 */
  showMechanicCard: (mechanicName: string, index: number) => {
    sendSupersetTrackedEventToApp({
      prefix: 'common',
      eventName: 'magazine_home_show',
      label: mechanicName,
      code: 'mechanic_story',
      type: 'card',
      index,
    })
  },

  /** '마이클 정비사 이야기' 카드 클릭 */
  clickMechanicCard: (mechanicName: string, index: number) => {
    sendSupersetTrackedEventToApp({
      prefix: 'common',
      eventName: 'magazine_home_click',
      label: mechanicName,
      code: 'mechanic_story',
      type: 'card',
      index,
    })
  },

  // 1-6) 드라이브의 모든 것 (DriveAllSection)

  /** '드라이브의 모든 것' 카드 노출 */
  showDriveAllCard: (title: string) => {
    sendSupersetTrackedEventToApp({
      prefix: 'common',
      eventName: 'magazine_home_show',
      label: title,
      code: 'drive_all',
      type: 'card',
    })
  },

  /** '드라이브의 모든 것' 카드 클릭 */
  clickDriveAllCard: (title: string) => {
    sendSupersetTrackedEventToApp({
      prefix: 'common',
      eventName: 'magazine_home_click',
      label: title,
      code: 'drive_all',
      type: 'card',
    })
  },

  /** '드라이브의 모든 것' 전체보기 클릭 */
  clickDriveAllMore: () => {
    sendSupersetTrackedEventToApp({
      prefix: 'common',
      eventName: 'magazine_home_click',
      label: '드라이브의 모든 것 - 전체보기',
      code: 'drive_all_more',
      type: 'button',
    })
  },

  // 1-7) 주변 정비소 (PopularPlacesSection)

  /** '주변 정비소' 섹션 노출 */
  showNearbyShopSection: () => {
    sendSupersetTrackedEventToApp({
      prefix: 'common',
      eventName: 'magazine_home_show',
      label: '주변 정비소',
      code: 'nearby_shop',
      type: 'section',
    })
  },

  /** '주변 정비소' 카드 스크롤 (1회) */
  scrollNearbyShop: () => {
    sendSupersetTrackedEventToApp({
      prefix: 'common',
      eventName: 'magazine_home_scroll',
      label: '주변 정비소',
      code: 'nearby_shop',
      type: 'card',
    })
  },

  /** '주변 정비소' 카드 노출 */
  showNearbyShopCard: (placeName: string, index: number) => {
    sendSupersetTrackedEventToApp({
      prefix: 'common',
      eventName: 'magazine_home_show',
      label: placeName,
      code: 'nearby_shop',
      type: 'card',
      index,
    })
  },

  /** '주변 정비소' 카드 클릭 */
  clickNearbyShopCard: (placeName: string, index: number) => {
    sendSupersetTrackedEventToApp({
      prefix: 'common',
      eventName: 'magazine_home_click',
      label: placeName,
      code: 'nearby_shop',
      type: 'card',
      index,
    })
  },

  /** '주변 정비소' 내 위치 버튼 노출 */
  showNearbyShopLocationButton: () => {
    sendSupersetTrackedEventToApp({
      prefix: 'common',
      eventName: 'magazine_home_show',
      label: '내 위치',
      code: 'popular_shop_location',
      type: 'button',
    })
  },

  /** '주변 정비소' 내 위치 버튼 클릭 */
  clickNearbyShopLocationButton: () => {
    sendSupersetTrackedEventToApp({
      prefix: 'common',
      eventName: 'magazine_home_click',
      label: '내 위치',
      code: 'popular_shop_location',
      type: 'button',
    })
  },

  // ==========================================
  // 2) 매거진 - 차량관리
  // ==========================================

  /** 화면 노출 */
  showCarcarePage: () => {
    sendSupersetTrackedEventToApp({
      prefix: 'common',
      eventName: 'magazine_carcare_show',
      label: '드라이브 매거진 - 차량관리',
      type: 'page',
    })
  },

  /** 상단 콘텐츠 카드 노출 */
  showCarcareTopContentCard: (title: string, index: number) => {
    sendSupersetTrackedEventToApp({
      prefix: 'common',
      eventName: 'magazine_carcare_show',
      label: title,
      code: 'top_contents',
      type: 'card',
      index,
    })
  },

  /** 상단 콘텐츠 카드 클릭 */
  clickCarcareTopContentCard: (title: string, index: number) => {
    sendSupersetTrackedEventToApp({
      prefix: 'common',
      eventName: 'magazine_carcare_click',
      label: title,
      code: 'top_contents',
      type: 'card',
      index,
    })
  },

  /** 상단 콘텐츠 스크롤 (1회) */
  scrollCarcareTopContents: () => {
    sendSupersetTrackedEventToApp({
      prefix: 'common',
      eventName: 'magazine_carcare_scroll',
      label: '관리의 정석',
      code: 'top_contents',
      type: 'card',
    })
  },

  /** 주제별 정렬 필터 클릭 */
  clickCarcareSortFilter: (sortName: string) => {
    sendSupersetTrackedEventToApp({
      prefix: 'common',
      eventName: 'magazine_carcare_click',
      label: sortName,
      code: 'topic_list',
      type: 'sort_filter',
    })
  },

  /** 주제 칩 노출 */
  showCarcareTopicChip: (chipLabel: string) => {
    sendSupersetTrackedEventToApp({
      prefix: 'common',
      eventName: 'magazine_carcare_show',
      label: chipLabel,
      code: 'topic_list',
      type: 'chip',
    })
  },

  /** 주제 칩 클릭 */
  clickCarcareTopicChip: (chipLabel: string) => {
    sendSupersetTrackedEventToApp({
      prefix: 'common',
      eventName: 'magazine_carcare_click',
      label: chipLabel,
      code: 'topic_list',
      type: 'chip',
    })
  },

  /** 주제 칩 스크롤 (1회) */
  scrollCarcareTopicChips: () => {
    sendSupersetTrackedEventToApp({
      prefix: 'common',
      eventName: 'magazine_carcare_scroll',
      label: '주제별 콘텐츠',
      code: 'topic_list',
      type: 'chip',
    })
  },

  /** 주제별 콘텐츠 카드 노출 */
  showCarcareTopicCard: (title: string, selectedChip: string) => {
    sendSupersetTrackedEventToApp({
      prefix: 'common',
      eventName: 'magazine_carcare_show',
      label: title,
      code: 'topic_list',
      type: 'card',
      target: selectedChip,
    })
  },

  /** 주제별 콘텐츠 카드 클릭 */
  clickCarcareTopicCard: (title: string, selectedChip: string) => {
    sendSupersetTrackedEventToApp({
      prefix: 'common',
      eventName: 'magazine_carcare_click',
      label: title,
      code: 'topic_list',
      type: 'card',
      target: selectedChip,
    })
  },

  // ==========================================
  // 3) 매거진 - 드라이브
  // ==========================================

  /** 화면 노출 */
  showDrivePage: () => {
    sendSupersetTrackedEventToApp({
      prefix: 'common',
      eventName: 'magazine_drive_show',
      label: '드라이브 매거진 - 드라이브',
      type: 'page',
    })
  },

  /** 상단 콘텐츠 카드 노출 */
  showDriveTopContentCard: (title: string, index: number) => {
    sendSupersetTrackedEventToApp({
      prefix: 'common',
      eventName: 'magazine_drive_show',
      label: title,
      code: 'top_contents',
      type: 'card',
      index,
    })
  },

  /** 상단 콘텐츠 카드 클릭 */
  clickDriveTopContentCard: (title: string, index: number) => {
    sendSupersetTrackedEventToApp({
      prefix: 'common',
      eventName: 'magazine_drive_click',
      label: title,
      code: 'top_contents',
      type: 'card',
      index,
    })
  },

  /** 상단 콘텐츠 스크롤 (1회) */
  scrollDriveTopContents: () => {
    sendSupersetTrackedEventToApp({
      prefix: 'common',
      eventName: 'magazine_drive_scroll',
      label: '슬기로운 초보 생활',
      code: 'top_contents',
      type: 'card',
    })
  },

  /** 주제별 정렬 필터 클릭 */
  clickDriveSortFilter: (sortName: string) => {
    sendSupersetTrackedEventToApp({
      prefix: 'common',
      eventName: 'magazine_drive_click',
      label: sortName,
      code: 'topic_list',
      type: 'sort_filter',
    })
  },

  /** 주제 칩 노출 */
  showDriveTopicChip: (chipLabel: string) => {
    sendSupersetTrackedEventToApp({
      prefix: 'common',
      eventName: 'magazine_drive_show',
      label: chipLabel,
      code: 'topic_list',
      type: 'chip',
    })
  },

  /** 주제 칩 클릭 */
  clickDriveTopicChip: (chipLabel: string) => {
    sendSupersetTrackedEventToApp({
      prefix: 'common',
      eventName: 'magazine_drive_click',
      label: chipLabel,
      code: 'topic_list',
      type: 'chip',
    })
  },

  /** 주제 칩 스크롤 (1회) */
  scrollDriveTopicChips: () => {
    sendSupersetTrackedEventToApp({
      prefix: 'common',
      eventName: 'magazine_drive_scroll',
      label: '주제별 콘텐츠',
      code: 'topic_list',
      type: 'chip',
    })
  },

  /** 주제별 콘텐츠 카드 노출 */
  showDriveTopicCard: (title: string, selectedChip: string) => {
    sendSupersetTrackedEventToApp({
      prefix: 'common',
      eventName: 'magazine_drive_show',
      label: title,
      code: 'topic_list',
      type: 'card',
      target: selectedChip,
    })
  },

  /** 주제별 콘텐츠 카드 클릭 */
  clickDriveTopicCard: (title: string, selectedChip: string) => {
    sendSupersetTrackedEventToApp({
      prefix: 'common',
      eventName: 'magazine_drive_click',
      label: title,
      code: 'topic_list',
      type: 'card',
      target: selectedChip,
    })
  },

  // ==========================================
  // 4) 매거진 - NOW
  // ==========================================

  /** 화면 노출 */
  showNowPage: () => {
    sendSupersetTrackedEventToApp({
      prefix: 'common',
      eventName: 'magazine_now_show',
      label: '드라이브 매거진 - NOW',
      type: 'page',
    })
  },

  /** NOW 콘텐츠 카드 노출 */
  showNowContentCard: (title: string) => {
    sendSupersetTrackedEventToApp({
      prefix: 'common',
      eventName: 'magazine_now_show',
      label: title,
      code: 'now_contents',
      type: 'card',
    })
  },

  /** NOW 콘텐츠 카드 클릭 */
  clickNowContentCard: (title: string) => {
    sendSupersetTrackedEventToApp({
      prefix: 'common',
      eventName: 'magazine_now_click',
      label: title,
      code: 'now_contents',
      type: 'card',
    })
  },

  // ==========================================
  // 5) 매거진 - 콘텐츠 상세
  // ==========================================

  /** 콘텐츠 상세 화면 노출 */
  showDetailPage: (title: string, contentId: number) => {
    sendSupersetTrackedEventToApp({
      prefix: 'common',
      eventName: 'magazine_detail_show',
      label: title,
      type: 'page',
      target: `contents_${contentId}`,
    })
  },

  /** 상단 공유하기 버튼 노출 */
  showDetailTopShare: (contentId: number) => {
    sendSupersetTrackedEventToApp({
      prefix: 'common',
      eventName: 'magazine_detail_show',
      label: '공유하기 (상단)',
      code: 'top_share',
      type: 'button',
      target: `contents_${contentId}`,
    })
  },

  /** 상단 공유하기 버튼 클릭 */
  clickDetailTopShare: (contentId: number) => {
    sendSupersetTrackedEventToApp({
      prefix: 'common',
      eventName: 'magazine_detail_click',
      label: '공유하기 (상단)',
      code: 'top_share',
      type: 'button',
      target: `contents_${contentId}`,
    })
  },

  /** 하단 CTA 버튼 클릭 */
  clickDetailCta: (ctaLabel: string, contentId: number) => {
    sendSupersetTrackedEventToApp({
      prefix: 'common',
      eventName: 'magazine_detail_click',
      label: ctaLabel,
      code: 'cta',
      type: 'button',
      target: `contents_${contentId}`,
    })
  },

  /** 공유 영역 버튼 노출 (카카오톡 / 링크복사 / 더보기) */
  showDetailShareButton: (channel: string, contentId: number) => {
    sendSupersetTrackedEventToApp({
      prefix: 'common',
      eventName: 'magazine_detail_show',
      label: channel,
      code: 'share',
      type: 'button',
      target: `contents_${contentId}`,
    })
  },

  /** 공유 영역 버튼 클릭 (카카오톡 / 링크복사 / 더보기) */
  clickDetailShareButton: (channel: string, contentId: number) => {
    sendSupersetTrackedEventToApp({
      prefix: 'common',
      eventName: 'magazine_detail_click',
      label: channel,
      code: 'share',
      type: 'button',
      target: `contents_${contentId}`,
    })
  },

  /** 외부 공유용 / 상단 다운로드 버튼 클릭 */
  clickDetailTopDownload: (contentId: number) => {
    sendSupersetTrackedEventToApp({
      prefix: 'common',
      eventName: 'magazine_detail_click',
      label: '다운로드',
      code: 'top_download',
      type: 'button',
      target: `contents_${contentId}`,
    })
  },

  /** 외부 공유용 / 하단 다운로드 버튼 클릭 */
  clickDetailBottomDownload: (contentId: number) => {
    sendSupersetTrackedEventToApp({
      prefix: 'common',
      eventName: 'magazine_detail_click',
      label: '다운로드',
      code: 'bottom_download',
      type: 'button',
      target: `contents_${contentId}`,
    })
  },

  /** 좋아요 버튼 클릭 */
  clickDetailLike: (title: string, contentId: number) => {
    sendSupersetTrackedEventToApp({
      prefix: 'common',
      eventName: 'magazine_detail_click',
      label: title,
      code: 'like',
      type: 'button',
      target: `contents_${contentId}`,
    })
  },

  /** 좋아요 버튼 클릭 해제 */
  clickDetailUnlike: (title: string, contentId: number) => {
    sendSupersetTrackedEventToApp({
      prefix: 'common',
      eventName: 'magazine_detail_click',
      label: title,
      code: 'unlike',
      type: 'button',
      target: `contents_${contentId}`,
    })
  },
} as const
